<script lang="ts">
  import ArrowLink from "$lib/atoms/ArrowLink.svelte";

  export let name: string;
  export let jobs: any[];

  $: count = jobs.filter((j) => j.departments[0].name === name).length;
</script>

<a
  href="/careers/open-roles?dep={encodeURIComponent(name)}"
  class="flex flex-col p-5 bg-white rounded-md shadow-[-14px_15px_52px_0px_rgba(0,_0,_0,_0.06)] no-underline text-inherit flex-auto"
>
  <div class="flex-auto">
    <div class="type:h4 mb-2">{name}</div>
    <div>{count} Opening{count > 1 ? "s" : ""}</div>
  </div>
  <div class="mt-8">
    <ArrowLink class="reduced sentence-case hover-red-bg">See roles</ArrowLink>
  </div>
</a>
